export default __webpack_public_path__ + "static/media/service-img4.d9ec2752.jpg";